module.exports = __webpack_public_path__ + "img/icon-heart.188f293d.png";